<template>
	<div class="end-run">
		<div v-if="isDisplayMessage" class="message flex-centerize">
			<div class="done-text">{{ message || messageDefault }}</div>
			<SIcon name="succ-sign" />
		</div>
	</div>
</template>

<script>
import * as WorkflowNodeService from '@/utils/workflow-node-service';
import { endRunBehaviour } from './flow-run-service';

import { FLOW_RUNNER_END_RUN_ACTION_TYPES } from '@/components/BlockEditorWidget/FieldSettings/EndRunButtonsFieldSettings/end-run-field.const.js';

const { DISPLAY_MESSAGE, NO_ACTION } = FLOW_RUNNER_END_RUN_ACTION_TYPES;

export default {
	name: 'EndRun',
	props: {
		data: { type: Object, required: true },
	},
	data() {
		return {
			messageDefault: 'Done',
			message: '',
		};
	},
	computed: {
		isDisplayMessage() {
			return [DISPLAY_MESSAGE, NO_ACTION].includes(this.action);
		},
		action() {
			return this.data.output ? WorkflowNodeService.getHiddenFieldsFromTestResult(this.data.output)['action'] : NO_ACTION;
		},
	},
	methods: {
		async runWidget(widgetData, callback) {
			const nodeRunIdPromise = {};
			const submitCallback = () => console.log('EndRun submit');
			const cancelCallback = () => console.log('EndRun cancelCallback');
			const widgetObj = { widgetData, nodeRunIdPromise, submitCallback, cancelCallback };
			callback(widgetObj);
		},
	},
	mounted() {
		endRunBehaviour(
			this.action,
			this.data,
			(msg) => (this.message = msg),
			(widgetData) => this.runWidget(widgetData, (params) => this.$emit('runWidget', params))
		);
	},
};
</script>

<style scoped lang="scss">
.done-text {
	margin: -4px 10px 0 0;
	color: var(--signup-grey);
}
</style>
